import { FAQ_ITEMS } from '@/components/FAQ/FAQModel';

/**
 * Agrupamento do FAQ.
 *
 * O conteúdo continua vindo inteiro de FAQModel.js — nenhuma pergunta
 * ou resposta foi reescrita. Aqui só se decide em qual tema cada id
 * cai, e em que ordem aparece dentro dele.
 */
export const GRUPOS = [
  {
    id: 'participar',
    hue: 'rosa',
    nome: 'Como participar',
    ids: [1, 3, 5, 10],
  },
  { id: 'encontros', hue: 'coral', nome: 'Os encontros', ids: [4, 11, 9] },
  {
    id: 'comunidade',
    hue: 'ameixa',
    nome: 'Leitura e comunidade',
    ids: [2, 7, 8, 6],
  },
];

/** Âncora estável para link direto: /faq#quanto-custa-participar */
export const ancora = (pergunta) =>
  pergunta
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 44);

/**
 * As respostas trazem '\n\n' entre blocos e marcadores '•'.
 * Vira parágrafo e lista de verdade em vez de texto corrido.
 */
export const estruturarResposta = (texto) =>
  texto.split('\n\n').map((bloco) => {
    const linhas = bloco.split('\n');
    const itens = linhas
      .filter((l) => l.trim().startsWith('•'))
      .map((l) => l.replace('•', '').trim());

    if (!itens.length) return { tipo: 'paragrafo', texto: bloco };

    const introducao = linhas
      .filter((l) => l.trim() && !l.trim().startsWith('•'))
      .join(' ');

    return { tipo: 'lista', introducao, itens };
  });

/** Perguntas de um grupo, na ordem definida acima. */
export const perguntasDoGrupo = (grupo) =>
  grupo.ids
    .map((id) => FAQ_ITEMS.find((item) => item.id === id))
    .filter(Boolean);
